import { isRoomUnavailable } from '@/v2/hooks/useCheckAppointmentWarnings'

// The first of the other rooms whose warnings check came back without a room
// conflict. Nothing until every check is back, so the pick follows the list
// order instead of whichever response lands first.
const findFreeRoom = (otherRooms, checks) => {
  if (checks.some(check => !check.isSuccess)) return

  return otherRooms.find(
    (room, index) => !isRoomUnavailable(checks[index].warnings)
  )
}

export default findFreeRoom
